import React, { useContext } from 'react';
import { Tooltip, Badge, InfoIcon } from '@wix/wix-base-ui';

import { TranslationContext } from '../context/TranslationContext';

export const AnimationSectionSuffix: React.FC<{
  animationName: string;
  tooltipText: string;
  disabled?: boolean;
}> = ({ animationName, tooltipText, disabled }) => {
  const { translate } = useContext(TranslationContext);
  if (animationName === 'None') {
    return <InfoIcon text={translate(tooltipText)} shouldTranslate={false} />;
  }
  return (
    <Tooltip
      content={translate(tooltipText)}
      interactive={true}
      closeOnContentMouseClick={true}
      shouldTranslate={false}
    >
      <Badge
        skin={disabled ? 'general' : 'success'}
        value={translate(`name_${animationName.toLowerCase()}`)}
        uppercase
        shouldTranslate={false}
      />
    </Tooltip>
  );
};
